export const UPDATE_AVAILABLE_FUNDS = 'INVESTMENT/UPDATE_AVAILABLE_FUNDS'

export const updateAvailableFunds = (funds) => {
  return {
    type: UPDATE_AVAILABLE_FUNDS,
    payload: funds,
  }
}
